export default __webpack_public_path__ + "static/media/al_ameen.ee1a664c.png";